import { environments, getEnvironment } from "./environment";

export const featureNames = {
    STOCKLEVELS: "stock_levels"
};

const features = {
    [featureNames.STOCKLEVELS]: {
        allowedEnvironments: [environments.LOCAL]
    }
};

export const isFeatureEnabled = feature => {
    const { allowedEnvironments } = features[feature];
    const environment = getEnvironment();
    return allowedEnvironments.includes(environment);
};
